import { render, staticRenderFns } from "./DialogAtualizarSenha.vue?vue&type=template&id=01e60522&scoped=true&"
import script from "./DialogAtualizarSenha.vue?vue&type=script&lang=js&"
export * from "./DialogAtualizarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e60522",
  null
  
)

export default component.exports